import { ModalWrapper } from "src/utils/fw"
import { isMember, leaderboardOptIn, modalColor } from "../utils"
import { AgendaSidebar } from "../components/AgendaSidebar"
import auditoriumOne, { getCurrentSession, SessionsComponent } from "../data/auditoriumOne"
import { assignAchievement } from "src/components/Leaderboard"
import { achievements } from "../data/achievements"
import { userID } from "src/utils/datalayer"


const memberLinks = [
	{
		height: "15.7%",
		href: "/atrium",
		isExternal: false,
		label: "Atrium",
		left: "38.3%",
		top: "80.9%",
		width: "7.6%",
	},
	{
		height: "15.7%",
		href: "https://isfcongress.tkeventsregistration.com/2024-feedbackaud1/",
		label: "Feedback",
		left: "46.1%",
		target: "_blank",
		top: "80.9%",
		width: "7.6%",
		onClick: () => {
			const session = getCurrentSession(auditoriumOne())
			if (!session) return;

			//check if session has ID
			const achID = achievements.find(it => it.name === `Provide Feedback - ${session.title}`)?.id
			
			if (!achID) return;
			if (leaderboardOptIn) assignAchievement({
                achievementId: achID,
                eventId: "161759",
                userId: userID
            })
		}
	},
	{
		height: "15.7%",
		label: "Slido",
		left: "54.1%",
		top: "80.9%",
		width: "7.6%",
		modal: <ModalWrapper wrapperStyle={{height: "fit-content", maxHeight: "100%", background: modalColor}}>
			<iframe src="https://app.sli.do/event/5KaWzBctKJsDXeEDqUFPN4" height="100%" width="100%" frameBorder="0" style="height: 95.8vh; width: 400px" title="Slido"></iframe>
		</ModalWrapper>,
		modalOverrides: {
			backdropStyle: {
				justifyContent: "flex-start",
				"background": "none"
			},
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/4570965-671963d26d333.png",
	extras: (
		<>
			<SessionsComponent sessions={auditoriumOne()} />
			<div style={{
				height: "70.4%",
				left: "19%",
				top: "5.1%",
				width: "62.05%",
				position: "absolute"
			}}>
				<iframe
					src="https://vimeo.com/event/4672872/embed/b7e4273441?autoplay=1&pip=0"
					// src="https://video.ibm.com/embed/26199405?autoplay=true&showtitle=false"
					allowfullscreen
					disablePictureInPicture
					allow="autoplay"
					style={{
						height: "100%",
						width: "100%",
						border: 0
					}}
				/>
			</div>
			<div style={{
				height: "85.1%",
				left: "82.3%",
				top: "2.1%",
				width: "16.7%",
				position: "absolute",
				textAlign: "right"
			}}>
				<AgendaSidebar agenda={auditoriumOne()} />
			</div>
		</>
	),
	links: [
		...(isMember ? memberLinks : []),
	],
	name: "auditorium",
}
